const getters = {
    getVendorTypeList(state) {
        return state.vendorTypeList;
    },
    getVendorType(state) {
        return state.vendorType;
    }
}

export default getters;